function generateYearsArray() {
  const startYear = 1947;
  const currentYear = new Date().getFullYear();
  const yearsArray = [];
  for (let year = currentYear; year >= startYear; year--) {
    yearsArray.push(year.toString());
  }
  return yearsArray;
}

let dropData = generateYearsArray();

const KYCVerificationConfig = [
  {
    name: "VerticalSection",
    section: "PersonAndBusinessDetails",
    ValidationName: "VerticalSection1",
    sections: [
      {
        name: "Sales_Person_Details",
        fields: [
          {
            id: Math.random() * 10,
            name: "Sales_Person_Mobile_Number",
            label: "Salesperson Mobile Number",
            type: "apiButtonInput",
            masterName: "UserByNumber",
            header: {
              usertype: "sales",
              Licensee: process.env.REACT_APP_ERP_BACKEND_LICENSEE_CODE,
              Company: process.env.REACT_APP_ERP_BACKEND_COMPANY_CODE,
              Branch: process.env.REACT_APP_ERP_BACKEND_BRANCH_CODE,
            },
            max: 10,
            isRequired: true,
            ValidationType: "VALID_STRING",
            disabled: false,
            autoFocus: true,
          },
          {
            id: Math.random() * 10,
            name: "Sales_Person_Name",
            label: "Salesperson Name",
            type: "text",
            min: 2,
            isRequired: true,
            disabled: true,
            ValidationType: "VALID_STRING",
          },
          {
            id: Math.random() * 10,
            name: "Search_Account",
            label: "Search Account",
            type: "apiButtonInput",
            masterName: "SearchAccount",
            header: { usertype: "sales", "X-GraphQL-Server": "secondary" },
            variable: { searchField: "Unique_Id" },
            min: 2,
            max: Infinity,
            isRequired: true,
            disabled: false,
          },
          {
            id: Math.random() * 10,
            name: "Account_ID",
            label: "Account",
            type: "text",
            min: 2,
            isRequired: true,
            disabled: true,
            ValidationType: "VALID_STRING",
          },
        ],
      },
      {
        name: "Personal_Details",
        VerticalSection: true,
        fields: [
          {
            id: Math.random() * 10,
            name: "Residential_Address",
            label: "Residential Address",
            type: "text",
            isRequired: true,
          },
          {
            id: Math.random() * 10,
            name: "Pincode",
            label: "Pincode",
            type: "number",
            header: {
              usertype: "sales",
              Licensee: process.env.REACT_APP_ERP_BACKEND_LICENSEE_CODE,
              Company: process.env.REACT_APP_ERP_BACKEND_COMPANY_CODE,
              Branch: process.env.REACT_APP_ERP_BACKEND_BRANCH_CODE,
            },
            min: 6,
            max: 6,
            isRequired: true,
            ValidationType: "VALID_STRING",
          },
          {
            id: Math.random() * 10,
            name: "Sidebyside",
            Subfields: [
              {
                id: Math.random() * 10,
                name: "City",
                label: "City",
                setvalue: "City",
                type: "text",
                min: 0,
                max: Infinity,
                isRequired: true,
              },
              {
                id: Math.random() * 10,
                name: "State",
                label: "State",
                setvalue: "State",
                type: "text",
                min: 0,
                max: Infinity,
                isRequired: true,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "VerticalSection",
    section: "OwnerAndDocumentDetails",
    ValidationName: "VerticalSection2",
    sections: [
      {
        name: "Business_Details",
        VerticalSection: true,
        fields: [
          {
            id: Math.random() * 10,
            name: "Business_Start_Year",
            label: "Business Start Year",
            type: "inputdrop",
            dropdowncontent: dropData,
            isRequired: false,
          },
          {
            id: Math.random() * 10,
            name: "GST_Number",
            label: "GST Registration Number",
            type: "text",
            min: 2,
            isRequired: false,
            AllCaps: true,
          },
          {
            id: Math.random() * 10,
            name: "Transport_Association_Registration_Number",
            label: "Transport Association Registration Number",
            type: "text",
            min: 2,
            max: 10,
            isRequired: false,
            AllCaps: true,
          },
          {
            id: Math.random() * 10,
            name: "Broker_Registration_Number_GOI",
            label: "Broker Registration Number GOI",
            type: "text",
            min: 10,
            max: 100,
            isRequired: false,
            AllCaps: true,
          },
          {
            id: Math.random() * 10,
            name: "MSME_Number",
            label: "MSME Number",
            type: "text",
            // min: 6,
            // max: 6,
            isRequired: false,
            AllCaps: true,
          },
          {
            id: Math.random() * 10,
            name: "Reference_Of_Transporter_One",
            label: "Reference of Known Transporter Name",
            type: "text",
            min: 2,
            isRequired: false,
          },
          {
            id: Math.random() * 10,
            name: "Transporter_One_MobileNumber",
            label: "Transporter Mobile Number",
            type: "text",
            min: 10,
            max: 10,
            isRequired: false,
          },
          {
            id: Math.random() * 10,
            name: "Reference_Of_Transporter_Two",
            label: "Reference of Known Transporter Name",
            type: "text",
            min: 2,
            isRequired: false,
          },
          {
            id: Math.random() * 10,
            name: "Transporter_Two_MobileNumber",
            label: "Transporter Mobile Number",
            type: "text",
            min: 10,
            max: 10,
            isRequired: false,
          },
        ],
      },
      {
        name: "Fleet_Owner_Details",
        VerticalSection: true,
        fields: [
          {
            id: Math.random() * 10,
            name: "Are_you_a_fleet_Owner",
            label: "Are You A Fleet Owner",
            type: "checkbox",
            isRequired: false,
          },
          {
            id: Math.random() * 10,
            name: "No_Of_Vehicle_Owned",
            label: "Number Of Own Vehicles",
            type: "number",
            min: 1,
            isRequired: false,
          },
          {
            id: Math.random() * 10,
            name: "Own_Vehicle_No",
            label: "Own Vehicle Number",
            type: "text",
            min: 6,
            max: 10,
            isRequired: false,
            AllCaps: true,
          },
        ],
      },
    ],
  },
  {
    name: "Documents",
    label: "Documents",
    fields: [
      {
        id: Math.random() * 10,
        name: "RC_Photo",
        label: "RC Photo",
      },
      {
        id: Math.random() * 10,
        name: "Office_Board_Photo",
        label: "Office Name Board Photo",
      },
      {
        id: Math.random() * 10,
        name: "Office_Inside_Photo",
        label: "Office Inside Photo",
      },
      {
        id: Math.random() * 10,
        name: "Selfie_With_The_Account_Owner",
        label: "Selfie With The Account Owner",
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Shop_Act_Licence",
        label: "Shop Act License",
      },
      {
        id: Math.random() * 10,
        name: "GST_Certificate",
        label: "GST Certificate",
      },
      {
        id: Math.random() * 10,
        name: "MSME_Certificate",
        label: "MSME Certificate",
      },
    ],
  },
];

export { KYCVerificationConfig };
